module.exports = __webpack_public_path__ + "img/done.0d3b82d9.svg";